export default __webpack_public_path__ + "3e9fe66973d7efb3209cd2d4f3e61706.png";